<template lang="html">
 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
      <p style="position: absolute; color: White; top: 40%; left: 40%;">
        <img src='../../assets/snakes.gif' /></p>
    </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">Snakebite Management</h4>
            <div style="padding-top:20px;padding-bottom:20px;">  <download-excel
                  class="btn btn-success btn-sm"
                  :data="items"
                  :fields="json_fields"
                  name="filename.xls"
                >
                  Download as Excel
                </download-excel></div>
              <div class="justify-content-centermy-1 row">
                 <b-form-fieldset horizontal label="Rows per page" class="col-6">
                  <b-form-select :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}]" v-model="perPage">
                  </b-form-select>
                </b-form-fieldset>
                <b-form-fieldset horizontal label="Filter" class="col-6">
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                </b-form-fieldset>
              </div>
              <div class="table-responsive">
              <template>
                <b-table striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" style="font-weight: 200;" response="true">
                   <template id="dishg" slot="createddate" slot-scope="item">
                     {{item.item.createddate.slice(0,10)}}
                  </template>
             <template id="diuo" v-slot:cell(linktonews)="row">
  <a v-bind:href="row.item.linktonews" target="_blank">{{row.item.linktonews}}</a>
</template>
                  <template id="dis"  v-slot:cell(status)="row">
  <router-link class="btn btn-warning" :to="'/editsnakebitemanagement/' + row.item._id">Edit</router-link>
</template>
                 <template id="id"  v-slot:cell(_id)="row">
  <router-link class="btn btn-success" :to="'/snakebitemanagementview/' + row.value">View</router-link>
</template>
                    <template id="del"  v-slot:cell(hospitalized)="row">
  <button class="btn btn-danger" @click="deleteSnake(row)">Delete</button>
</template>
                </b-table>
              </template>
              </div>
               <div class="justify-content-center row my-1">
                <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
              </div>
        </div>
     </div>
    </div>
  </div>
  </section>
 </template>
<script lang="js">
import axios from 'axios'
export default {
  name: 'news',
  data () {
    return {
      items: [],
      fields: [
        // {
        //   key: 'createddate',
        //   label: 'Created Date',
        //   sortable: 'true'
        // },
        // {
        //   key: 'state',
        //   label: 'State',
        //   sortable: true
        // },
        // {
        //   key: 'affectedpeople',
        //   label: 'Affected People',
        //   sortable: true
        // },
        // {
        //   key: 'tradition',
        //   label: 'Traditional Healing',
        //   sortable: true
        // },
        // {
        //   key: 'note',
        //   sortable: true,
        //   label: 'Notes'
        // },
        {
          key: 'linktonews',
          label: 'Link'
        },
        {
          key: 'status',
          label: 'Edit Details',
          sortable: true
        },
        {
          key: '_id',
          label: 'View Details',
          sortable: true
        },
        {
          key: 'hospitalized',
          label: 'Delete'
        }
        // {
        //   key: 'characteristics',
        //   label: 'Delete',
        //   sortable: true
        // },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      striped: true,
      loading: false,
      username: localStorage.getItem('username'),
      is_admin: localStorage.getItem('is_admin'),
      id: localStorage.getItem('id'),
          json_fields: {
        'Created Date': 'createddate',
        'State': 'state',
        'Affected People': 'affectedpeople',
        'Traditional Healing': 'tradition',
        'Notes': 'note',
        'Link to News': 'linktonews',
        'status': 'status',
        'Activity': 'activity',
        'Hopitalized': 'hospitalized'
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      axios({
        url: 'https://api.indiansnakes.org/snakebiteinfo/all',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.items = response.data.data
        this.loading = false
      }).catch(e => {
        this.errors.push(e)
      })
    },

    deleteSnake: function (item) {
      var vm = this
      vm.item = item.item._id
      this.loading = true
      axios({
        method: 'DELETE',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        url: 'https://api.indiansnakes.org/snakebiteinfo/delete/',
        data: {
          id: vm.item
        }
      }).then(response => {
        alert('Successfully Deleted Item')
        this.getList()
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    }
  }
}
</script>
<style>
/* .main-panel {
    width: calc(100% - 255px)!important;
} */
</style>


// WEBPACK FOOTER //
// src/views/forms/viewsnakebitemanagement.vue